import { useSelector } from 'react-redux';

import { SpartacuxProductDiscoveryDomainState } from '@/productDiscovery/productDiscovery.model';
import { selectBulkOfProduct } from '@/productDiscovery/ProductPage/common/modules/BulkPurchase/ducks/BulkPurchase.selectors';
import { getBulkPurchaseThresholdIndex } from '@/productDiscovery/ProductPage/common/modules/BulkPurchase/utils/getBulkPurchaseThresholdIndex';

export function useBulkCouponValue(
  productId: number,
  quantity: number,
  unitPrice: number,
) {
  const bulkPurchaseData = useSelector(
    (state: SpartacuxProductDiscoveryDomainState) =>
      selectBulkOfProduct(state, productId),
  );

  if (!bulkPurchaseData) {
    return undefined;
  }

  const aplicableThresholdIndex = getBulkPurchaseThresholdIndex(
    bulkPurchaseData.thresholds,
    quantity,
  );

  if (aplicableThresholdIndex === -1) {
    return 0;
  }

  const threshold = bulkPurchaseData.thresholds[aplicableThresholdIndex];

  return (quantity * unitPrice * threshold.percent) / 100;
}
